"use client";

import React, { useState } from "react";
import styles from "./TextInput.module.scss";
import clsx from "clsx";

/**
 *
 * TextInput
 *
 */
const TextInput = ({
  label = "",
  name = "",
  value = "",
  placeholder = "",
  background = "bg-transparent",
  required = false,
  type = "text",
  onChange = (ev) => {},
  ...props
}) => {
  const [_value, setValue] = useState(value);

  return (
    <div className={clsx(styles["text-input"], "stack gap-2")} {...props}>
      <label htmlFor={name}>{label}</label>
      <input
        type={type}
        name={name}
        id={name}
        value={_value}
        placeholder={placeholder}
        className={`rounded-button border border-border-color color-border-color w-full h-[70px] flex justify-between items-center px-10 leading-none text-black ${background}`}
        required={required}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e);
        }}
      />
    </div>
  );
};

export default TextInput;
